import { api } from './api';

// Drives a full-site audit in small steps so no single request outlives the
// edge's ~100s response cut (a whole-site run in one request gets killed):
//   start  -> server refreshes the page map and returns the page plan
//   pages  -> a few pages per request, homepage last and alone (WAVE + PDF)
//   finish -> account score = the average of the run's pages
// onProgress({ done, total }) fires after each batch.
export async function runSiteAudit(accountId, { onProgress, chunkSize = 3 } = {}) {
  const base = `/api/admin/accounts/${accountId}/audit-now`;
  const plan = await api.post(base, { start: true });
  const pages = plan.pages || [];
  const total = pages.length;

  const others = pages.filter((p) => p.path !== '/');
  const chunks = [];
  for (let i = 0; i < others.length; i += chunkSize) chunks.push(others.slice(i, i + chunkSize));
  const home = pages.filter((p) => p.path === '/');
  if (home.length) chunks.push(home);

  const notFound = [];
  const failed = [];
  let done = 0;
  onProgress?.({ done, total });
  for (const chunk of chunks) {
    try {
      const res = await api.post(base, { runId: plan.runId, pages: chunk });
      for (const r of res.pageBatch || []) {
        if (r.notFound) notFound.push(r.path);
        else if (r.error) failed.push({ path: r.path, error: r.error });
      }
    } catch (err) {
      for (const p of chunk) failed.push({ path: p.path, error: err?.data?.error || err?.message || 'failed' });
    }
    done += chunk.length;
    onProgress?.({ done, total });
  }

  const fin = await api.post(base, { runId: plan.runId, finish: true });
  return {
    runId: plan.runId,
    score: fin.score ?? null,
    worstScore: fin.worstScore ?? null,
    pagesAudited: fin.pagesAudited ?? 0,
    audit: fin.audit || null,
    total,
    notFound,
    failed,
    pageMapRefresh: plan.pageMapRefresh || null,
  };
}
